// extracted by mini-css-extract-plugin
module.exports = {"accountContainer":"styles_accountContainer__3c2OC","dataContainer":"styles_dataContainer__1uFCJ"};